import axios, { AxiosResponse } from 'axios';
import { getAccessToken } from './accessToken';
import { URL_LIBRANZAS, LIBRANZAS_APIKEY } from '@/constants/api-constants';

export const getExcelLibranzas = (requestId: string): Promise<AxiosResponse | undefined> =>
    getAccessToken()
        .then((tokenResponse) => {
            const token = tokenResponse?.data.data.id_token;
            return axios.request({
                method: 'post',
                url: `${URL_LIBRANZAS}/consulta-deudores/descargar-excel`,
                headers: {
                    apikey: LIBRANZAS_APIKEY,
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: { requestId },
            });
        })
        .catch((error) => {
            console.error(error);
            return undefined;
        });
